import { AuthCallbackComponent } from '../core/oidc/auth-callback/auth-callback.component';
import { LinkCallbackComponent } from '../core/oidc/link-callback/link-callback.component'; 
import { AccessDeniedComponent } from '../pages/access-denied/access-denied.component';
import { LoginComponent } from '../pages/login/login.component';
import { AuthguardService } from '../shared/authguard.service';
import { MfaSetupComponent } from '../pages/mfa/mfa-setup/mfa-setup.component';
import { MfaAuthorizeComponent } from 'app/pages/mfa/mfa-authorize/mfa-authorize.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'survey',
    loadChildren: () =>
      import('../survey/survey.module').then((m) => m.SurveyModule),
  },
  {
    path: 'salesplanner',
    loadChildren: () =>
      import('./salesplanner/salesplanner.module').then(
        (m) => m.SalesPlannerModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'xrmdashboard',
    loadChildren: () =>
      import('./xrmdashboard/xrmdashboard.module').then(
        (m) => m.XrmDashboardModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'cobuyer',
    loadChildren: () =>
      import('./cobuyer/cobuyer.module').then(
        (m) => m.CobuyerModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./xrmdashboard/xrmdashboard.module').then(
        (m) => m.XrmDashboardModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'pushtodms',
    loadChildren: () =>
      import('./pushtodms/pushtodms.module').then((m) => m.PushtodmsModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'tradein',
    loadChildren: () =>
      import('./tradein/tradein.module').then((m) => m.TradeinModule),
  },

  {
    path: 'trade',
    loadChildren: () =>
      import('./desking/trade-vehicles/trade-vehicles.module').then(
        (m) => m.TradeVehiclesModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'desking',
    loadChildren: () =>
      import('./desking/desking.module').then((m) => m.DeskingModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'customer',
    loadChildren: () =>
      import('./customer/customer.module').then((m) => m.CustomerModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'customer-quickentry',
    loadChildren: () =>
      import('./customer/customer-quickentry/customer-quickentry.module').then(
        (m) => m.CustomerQuickentryModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'rbf',
    loadChildren: () =>
      import('./customer/rbf/rbf.module').then((m) => m.RbfModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'xrminventory',
    loadChildren: () =>
      import('./inventory/inventory.module').then((m) => m.InventoryModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'appraisal',
    loadChildren: () =>
      import('./appraisal/appraisal.module').then((m) => m.AppraisalModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'gmintegration',
    loadChildren: () =>
      import('./gm-integration/gm-integration.module').then(
        (m) => m.GmIntegrationModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'reportbuilder',
    loadChildren: () =>
      import('./reportbuilder/reportbuilder.module').then(
        (m) => m.ReportBuilderModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'sms',
    loadChildren: () => import('./sms/sms.module').then((m) => m.SmsModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'email',
    loadChildren: () => import('./email/email.module').then((m) => m.EmailModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'bbvideorecord',
    loadChildren: () =>
      import('./bombbomb/bombbomb.module').then((m) => m.BombbombModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'sales',
    loadChildren: () =>
      import('./sales/sales.module').then((m) => m.SalesModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./maintenance/maintenance.module').then((m) => m.MaintenanceModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./paymentview/paymentview.module').then(
        (m) => m.PaymentviewModule
      ),
    canActivate: [AuthguardService],
  },
  { path: 'login', component: LoginComponent },
  { path: 'mfasetup', component: MfaSetupComponent, canActivate: [AuthguardService] },
  { path: 'mfaauthorize', component: MfaAuthorizeComponent, canActivate: [AuthguardService] },
  {
    path: 'ddl',
    loadChildren: () =>
      import('./reportbuilder/reportbuilder.module').then(
        (m) => m.ReportBuilderModule
      ),
    canActivate: [AuthguardService],
  },
  { path: 'access_denied', component: AccessDeniedComponent },
  { path: '', redirectTo: './salesplanner', pathMatch: 'full' },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'link-callback',
    component: LinkCallbackComponent,
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./users/users.module').then((m) => m.UsersModule),
    canActivate: [AuthguardService],
  },
  {
    path: 'landingpage',
    loadChildren: () =>
      import('./landingpage/landingpage.module').then(
        (m) => m.LandingPageModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'scm',
    loadChildren: () =>
      import('./showroom-control-manager/showroom-control-manager.module').then(
        (m) => m.ShowroomControlManagerModule
      ),
    canActivate: [AuthguardService]
  },
  {
    path: 'insurance',
    loadChildren: () =>
      import('./insurance/insurance.module').then(
        (m) => m.InsuranceModule
      ),
    canActivate: [AuthguardService]
  },
  {

    path: 'customer-merge-search',
    loadChildren: () =>
      import('./customer/customer-merge-search/customer-merge-search.module').then(
        (m) => m.CustomerMergeSearchModule
      ),
    canActivate: [AuthguardService],
  },
  {
    path: 'event',
    loadChildren: () =>
      import('./event/event.module').then(
        (m) => m.EventModule
      ),
    canActivate: [AuthguardService]
  }

];

